export default {
    isGridOpen: state => state.gridIsOpen,
    isFormOpen: state => state.formIsOpen,
    isAdditionalTableOpen: state => state.additionalTableIsOpen,

    getDataTableOptions: state => state.dataTableOptions,
    getAdditionalDataTableOptions: state => state.additionalDataTableOptions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getFormActions: state => state.formActions,
    getAdditionalRowActions: state => state.additionalRowActions,
    getSearchFields: state => state.searchFields,
    getHeaderFields: state => state.headerFields,
    getAdditionalHeaderFields: state => state.additionalHeaderFields,

    getSelectPartnerDataTableOptions: state => state.selectPartnerDataTableOptions,
    getSelectPartnerRowActions: state => state.selectPartnerRowActions,
    getSelectPartnerHeaderFields: state => state.selectPartnerHeaderFields
}
